<script setup>
import { onMounted, onUnmounted } from 'vue'
import { useSeoMeta } from '@unhead/vue'
import { useGlobalStore } from '@stores/global'

const global = useGlobalStore()

onMounted(() => {
	UnicornStudio.init()
})
onUnmounted(() => {
	UnicornStudio.destroy()
})

useSeoMeta({
	title: () => global.pages.find((page) => page.path === 'playground')?.title ?? global.pages.find((page) => page.path === '/')?.title,
	description: () => global.pages.find((page) => page.path === 'playground')?.description ?? global.pages.find((page) => page.path === '/')?.description,
	image: () => global.pages.find((page) => page.path === 'playground')?.image ?? global.pages.find((page) => page.path === '/')?.image,
})
</script>

<template>
	<div class="unicorn-embed fixed h-dvh w-full touch-manipulation overflow-hidden" data-us-project-src="https://cdn.papercrowns.com/uni.json" data-us-scale="1" data-us-dpi="1.5" data-us-lazyload="true" data-us-production="true"></div>
</template>
